export default "__VITE_ASSET__e8b8e15c__"